import React from "react";
import './Legends.css';

function Legends({title}) {
    return (
        <div className="legend">
            <p className="mb-0 legend-text">{title}</p>
        </div>
    );
}

export default Legends;